import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import GuideQuestionCard from './GuideQuestionCard';
import { discussionGuideData, classroomActivities } from '../data/discussionGuideData';

const { FiBookOpen, FiPrinter, FiCheck, FiAward, FiEdit3 } = FiIcons;

export default function ClassroomGuide() {
  const [activeTab, setActiveTab] = useState(0);
  const [printedNote, setPrintedNote] = useState(false);

  const activeCategory = discussionGuideData[activeTab];

  const handlePrint = () => {
    window.print();
    setPrintedNote(true);
    setTimeout(() => setPrintedNote(false), 3000);
  };

  return (
    <section className="guide-section section-wrap" id="guide">
      <div className="section-intro">
        <div>
          <span className="section-kicker">EDUCATOR & PARENT RESOURCE</span>
          <h2>Classroom & Family <em>Discussion Guide.</em></h2>
        </div>
        <div className="guide-intro-actions">
          <button
            type="button"
            className="guide-print-btn"
            onClick={handlePrint}
            title="Print or save as PDF for classroom lessons"
          >
            <SafeIcon icon={printedNote ? FiCheck : FiPrinter} />
            <span>{printedNote ? 'Opening Print...' : 'Print Discussion Guide'}</span>
          </button>
        </div>
      </div>

      <p className="guide-lead-text">
        Designed for teachers, librarians, reading circles, and parents reading with children (ages 4–11).
        Spark inspiring discussions about purpose, overcoming tough moments, and celebrating unique dreams!
      </p>

      {/* Category Tabs */}
      <div className="guide-tabs" role="tablist">
        {discussionGuideData.map((cat, idx) => (
          <button
            key={cat.category}
            type="button"
            role="tab"
            aria-selected={activeTab === idx}
            className={`guide-tab ${activeTab === idx ? 'tab-active' : ''}`}
            onClick={() => setActiveTab(idx)}
          >
            <span className="tab-kicker">{cat.kicker}</span>
            <span className="tab-name">{cat.category}</span>
          </button>
        ))}
      </div>

      {/* Active Tab Questions */}
      <div className="guide-content-panel">
        <div className="guide-panel-header">
          <div>
            <span className="panel-kicker">{activeCategory.kicker} FOCUS</span>
            <h3 className="panel-title">{activeCategory.category}</h3>
            <p className="panel-subtitle">{activeCategory.subtitle}</p>
          </div>
          <div className="panel-icon-stamp">
            <SafeIcon icon={FiBookOpen} />
          </div>
        </div>

        <div className="guide-questions-list">
          {activeCategory.questions.map((q, qIndex) => (
            <GuideQuestionCard key={q.question} item={q} index={qIndex} />
          ))}
        </div>
      </div>

      {/* Interactive Hands-On Classroom Activities */}
      <div className="activities-container">
        <div className="activities-header">
          <div className="activities-badge">
            <SafeIcon icon={FiEdit3} /> HANDS-ON LEARNING
          </div>
          <h3>Classroom & Bedtime Activities</h3>
          <p>Bring the themes of <em>Binjamin the Dumpster</em> to life with interactive crafts & exercises.</p>
        </div>

        <div className="activities-grid">
          {classroomActivities.map((act) => (
            <div key={act.title} className="activity-card">
              <span className="activity-tag">
                <SafeIcon icon={FiAward} /> {act.badge}
              </span>
              <h4 className="activity-title">{act.title}</h4>
              <p className="activity-desc">{act.desc}</p>
              <div className="activity-materials">
                <strong>Suggested Materials:</strong> {act.materials}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
